// extracted by mini-css-extract-plugin
export default {"variation":"VariationBadge_variation__eq-Qq","positive":"VariationBadge_positive__GIrmA","negative":"VariationBadge_negative__WDcyI","neutral":"VariationBadge_neutral__lJ0xu"};